module.exports = __webpack_public_path__ + "img/toe-greek.46549c98.svg";